import { useForm } from 'react-hook-form'
import { useState } from 'react'

import CloseIcon from '../assets/icons/close-icon.svg'

import { postContactHugcare } from 'apis/contact.ts'

export default function HugcareContactModal({ setModalOpen }) {
  const closeModal = () => {
    setModalOpen(false)
  }
  const [submitModalOpen, setSubmitModalOpen] = useState(false)
  const openModal = () => {
    setSubmitModalOpen(true)
  }

  const [isSubmit, setIsSubmit] = useState(false)
  const {
    register,
    handleSubmit,
    formState: { isValid },
  } = useForm()

  const regEmail = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i
  const regPhone = /^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/

  const onSubmit = async (data) => {
    const postContactHugcareResponse = await postContactHugcare({
      company: data.company,
      name: data.name,
      phone: data.phone,
      email: data.email,
    })
    if (postContactHugcareResponse.error) {
      console.log(postContactHugcareResponse.message)
      return
    } else {
      console.log(postContactHugcareResponse)
    }
  }
  return (
    <div className='z-[999] w-full h-full bg-neutral-99 bg-opacity-80 fixed top-0 left-0 flex justify-center items-center overflow-auto'>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className='flex flex-col rounded-20 w-[300px] 2xs:w-[440px] sm:w-[640px] lg:w-[840px]'>
          <div className='flex items-center justify-between px-32 py-12 bg-sk-black rounded-t-20'>
            <p className='text-h1-semibold sm:text-title3-bold text-sk-white'>문의하기</p>
            <button type='button' onClick={closeModal}>
              <img src={CloseIcon} alt='' />
            </button>
          </div>
          <div className='flex flex-col gap-64 p-20 2xs:p-32 bg-sk-white rounded-b-20'>
            <div className='flex flex-col sm:grid sm:grid-cols-2'>
              <div className='flex'>
                <div className='flex items-center px-10 2xs:px-20 py-12 2xs:py-16 min-w-[100px] 2xs:min-w-[120px] lg:min-w-[140px] bg-neutral-99 border-t-solid border-t-[1px] border-sk-border-default'>
                  <p className='text-body2-semibold 2xs:text-body1-semibold lg:text-h2-semibold text-sk-default'>
                    소속
                  </p>
                  <p className='text-body1-medium 2xs:text-h2-medium text-sk-red'>*</p>
                </div>
                <input
                  {...register('company', { required: true })}
                  type='text'
                  className='outline-none px-10 2xs:px-20 py-12 2xs:py-16 items-center bg-sk-white border-t-solid border-t-[1px] border-sk-border-default min-w-[120px] 2xs:min-w-[168px] lg:min-w-[248px] text-body1-medium sm:text-h2-medium text-sk-default placeholder:text-body3-medium 2xs:placeholder:text-body2-medium lg:placeholder:text-body1-medium placeholder:text-sk-assistive'
                  placeholder='회사명을 입력해주세요'
                />
              </div>
              <div className='flex'>
                <div className='flex items-center px-10 2xs:px-20 py-12 2xs:py-16 min-w-[100px] 2xs:min-w-[120px] lg:min-w-[140px] bg-neutral-99 border-t-solid border-t-[1px] border-sk-border-default text-h2-medium text-sk-default placeholder:text-body3-medium 2xs:placeholder:text-body2-medium lg:placeholder:text-body1-medium placeholder:text-sk-assistive'>
                  <p className='text-body2-semibold 2xs:text-body1-semibold lg:text-h2-semibold text-sk-default'>
                    이름(직위)
                  </p>
                  <p className='text-body1-medium 2xs:text-h2-medium text-sk-red'>*</p>
                </div>
                <input
                  {...register('name', { required: true })}
                  type='text'
                  className='outline-none px-10 2xs:px-20 py-12 2xs:py-16 items-center bg-sk-white border-t-solid border-t-[1px] border-sk-border-default min-w-[120px] 2xs:min-w-[168px] lg:min-w-[248px] text-body1-medium sm:text-h2-medium text-sk-default placeholder:text-body3-medium 2xs:placeholder:text-body2-medium lg:placeholder:text-body1-medium placeholder:text-sk-assistive'
                  placeholder='이름을 입력해주세요'
                />
              </div>
              <div className='flex'>
                <div className='flex items-center px-10 2xs:px-20 py-12 2xs:py-16 min-w-[100px] 2xs:min-w-[120px] lg:min-w-[140px] bg-neutral-99 border-y-solid border-y-[1px] border-sk-border-default '>
                  <p className='text-body2-semibold 2xs:text-body1-semibold lg:text-h2-semibold text-sk-default'>
                    전화번호
                  </p>
                  <p className='text-body1-medium 2xs:text-h2-medium text-sk-red'>*</p>
                </div>
                <input
                  {...register('phone', { required: true, pattern: regPhone })}
                  type='text'
                  className='outline-none px-10 2xs:px-20 py-12 2xs:py-16 items-center bg-sk-white border-y-solid border-y-[1px] border-sk-border-default min-w-[120px] 2xs:min-w-[168px] lg:min-w-[248px] text-body1-medium sm:text-h2-medium text-sk-default placeholder:text-body3-medium 2xs:placeholder:text-body2-medium lg:placeholder:text-body1-medium placeholder:text-sk-assistive'
                  placeholder='전화번호를 입력해주세요'
                />
              </div>
              <div className='flex'>
                <div className='flex items-center px-10 2xs:px-20 py-12 2xs:py-16 min-w-[100px] 2xs:min-w-[120px] lg:min-w-[140px] bg-neutral-99 border-y-solid border-b-[1px] sm:border-y-[1px] border-sk-border-default'>
                  <p className='text-body2-semibold 2xs:text-body1-semibold lg:text-h2-semibold text-sk-default'>
                    이메일
                  </p>
                  <p className='text-body1-medium 2xs:text-h2-medium text-sk-red'>*</p>
                </div>
                <input
                  {...register('email', { required: true, pattern: regEmail })}
                  type='text'
                  className='outline-none px-10 2xs:px-20 py-12 2xs:py-16 items-center bg-sk-white border-y-solid border-b-[1px] sm:border-y-[1px] border-sk-border-default min-w-[120px] 2xs:min-w-[168px] lg:min-w-[248px] text-body1-medium sm:text-h2-medium text-sk-default placeholder:text-body3-medium 2xs:placeholder:text-body2-medium lg:placeholder:text-body1-medium placeholder:text-sk-assistive'
                  placeholder='이메일을 입력해주세요'
                />
              </div>
            </div>
            <div className='relative flex flex-col items-center'>
              {!isValid && (
                <p className='absolute bottom-[64px] sm:bottom-[78px] text-body2-medium 2xs:text-body1-medium text-sk-red'>
                  필수 항목을 모두 입력해주세요
                </p>
              )}
              <div className='flex items-center justify-center gap-16 2xs:gap-32'>
                <button
                  type='button'
                  className='px-16 py-12 2xs:px-36 sm:px-48 sm:py-16 button_white2 text-h2-medium sm:text-h1-medium text-sk-default'
                  onClick={closeModal}
                >
                  취소하기
                </button>
                <button
                  disabled={!isValid}
                  type='submit'
                  className='px-16 py-12 2xs:px-36 sm:px-48 sm:py-16 button_black text-sk-white text-h2-medium sm:text-h1-medium'
                  onClick={() => {
                    setIsSubmit((prev) => !prev)
                    openModal()
                  }}
                >
                  문의하기
                </button>
                {submitModalOpen && (
                  <HugcareContactModal setModalOpen={setSubmitModalOpen} isSubmit={isSubmit} />
                )}
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  )
}
